import React from 'react';
import { Building2, Rocket, Briefcase, Code2 } from 'lucide-react';

const HEADING = { fontFamily: "'Space Grotesk', system-ui, sans-serif" } as const;

const USE_CASES = [
  { icon: Building2, title: 'Agences', description: "Gérez plusieurs clients et projets simultanément. Suivez la rentabilité de chaque mission.", benefits: ['Multi-projets', 'Budget client', 'Portail client'] },
  { icon: Rocket, title: 'Startups', description: "Avancez vite sans sacrifier la visibilité. Produit, tech, business dans un seul espace.", benefits: ['Sprints agiles', 'Roadmap claire', 'Temps réel'] },
  { icon: Briefcase, title: 'PME', description: "Structurez vos projets internes. Contrôlez délais et budgets.", benefits: ['Vue direction', 'Rapports auto', 'Historique complet'] },
  { icon: Code2, title: 'Équipes Produit & IT', description: "De la roadmap au déploiement. Backlog, sprints, dépendances techniques.", benefits: ['Backlog priorisé', 'Dépendances', 'Intégrations'] },
];

export function UseCasesSection() {
  return (
    <section id="use-cases" className="py-24 md:py-32 bg-[#0a0a1a] relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16 md:mb-20">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#1e1e5a] text-[#a5b4fc] text-xs font-bold uppercase tracking-widest mb-6 border border-[#4f46e5]/30">
            <Briefcase className="h-3.5 w-3.5" />
            Cas d'usage
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-bold text-white mb-4 tracking-tighter" style={HEADING}>
            Adapté à votre réalité
          </h2>
          <p className="text-lg text-slate-400">
            Agence, startup, PME ou équipe produit — Lapyno s'adapte à votre façon de travailler.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {USE_CASES.map((useCase) => {
            const Icon = useCase.icon;
            return (
              <div
                key={useCase.title}
                className="group relative p-8 rounded-[2rem] bg-[#141432] border border-[#1e1e5a] hover:border-[#4f46e5]/50 transition-all duration-300 overflow-hidden"
              >
                <div className="absolute -top-20 -right-20 w-56 h-56 bg-[#4f46e5]/0 group-hover:bg-[#4f46e5]/15 blur-[80px] rounded-full transition-all duration-500" />
                <div className="relative">
                  <div className="inline-flex p-3 rounded-2xl bg-[#1e1e5a] text-[#a5b4fc] mb-5 border border-[#4f46e5]/20">
                    <Icon className="h-6 w-6" />
                  </div>
                  <h3 className="text-2xl font-bold text-white mb-3" style={HEADING}>{useCase.title}</h3>
                  <p className="text-slate-400 mb-5 leading-relaxed">{useCase.description}</p>
                  <div className="flex flex-wrap gap-2">
                    {useCase.benefits.map((benefit) => (
                      <span key={benefit} className="px-3 py-1 text-xs font-medium rounded-full bg-[#1e1e5a]/60 border border-white/5 text-slate-300">
                        {benefit}
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
